const angular = require('angular')
const jsSHA = require('jssha')

module.exports = ['$q', '$translate', '$utils', '$window',
  function ($q, $translate, $utils, $window) {
    /**
     * 注： 这里不要引入User，这里需要登录账号的信息应当做参数从其他页面传过来
     *     currentUser 当前登录的账号
     *     bindUser    绑定验证的账号
     * */

    function Authenticator(options) {
      this.fileName = options.fileName || '.coremail_authenticator' // .开头可隐藏文件
      this.filePath = options.path || this.getFilePath()
      this.directory = options.directory || 'coremail.hxphone'
      this.encryptKey = 'fie9wrnvd834w3fsafe8'
      this.ioskey = 'authenticatorAccount'
      this.ioskeyName = 'cn.coremail.hxphone'
      this.CUID = options.CUID // 当前登录账号邮件地址
    }

    Authenticator.prototype = {
      // 获取绑定的账号  注：对self.bindAccounts数据的管理很关键，性能问题！
      getBindAccounts: function () {
        const self = this
        const deferred = $q.defer()
        if (self.bindAccounts) {
          deferred.resolve(self.bindAccounts)
        } else {
          self.getAllAuthData().then(function (allAuthData) {
            console.log('get bind accounts:' + JSON.stringify(allAuthData))
            for (const account in allAuthData) {
              if (allAuthData.hasOwnProperty(account)) {
                if (account == self.CUID || allAuthData[account].owner == self.CUID) {
                  self.addBindAccounts(account)
                }
              }
            }
            if (!self.bindAccounts) {
              self.bindAccounts = []
            }
            deferred.resolve(self.bindAccounts)
          }, function (error) {
            deferred.reject(error)
          })
        }

        return deferred.promise
      },

      addBindAccounts: function (bindUser) {
        const self = this
        const accounts = {}

        if (!self.bindAccounts) {
          self.bindAccounts = []
        }
        angular.forEach(self.bindAccounts, function (email, index) {
          accounts[email] = email
        })
        if (!accounts[bindUser] && $utils.$email.test(bindUser)) {
          self.bindAccounts.push(bindUser)
        }
      },

      // 获取所有绑定账号信息, 如果传入当前登录账号则返回登录账号绑定的信息，否则返回所有
      getAllAuthData: function () {
        const deferred = $q.defer()

        deferred.resolve([])
        return deferred.promise
      },

      // userAuthData = {'user1@test.com' : {'Coremail' : {secret:'xx',...}}}
      // 无法获取key？这里需要分析错误的原因，1、文件被删除；2、文件内容被清空；3、对应的用户没有数据；4、未知。
      /** 获取绑定账号六位数验证码
       * bindUser  需要绑定验证的账号
       * */
      getDigitalCode: function (user) {
        const self = this
        const toTp = new TOTP()
        const deferred = $q.defer()
        let secret
        console.log('allAuthData are ' + JSON.stringify(self.allAuthData))
        if (self.allAuthData && self.allAuthData[user]) {
          secret = getSecret(self.allAuthData[user])
          console.log('secret is ---------' + secret)
          deferred.resolve(toTp.getOTP(secret))
        } else {
          self.getAllAuthData().then(function (allAuthData) {
            console.log('current account authData ' + JSON.stringify(allAuthData))
            secret = getSecret(allAuthData[user])
            if (secret) {
              deferred.resolve(toTp.getOTP(secret))
            } else {
              deferred.reject(user)
            }
          }, function (error) {
            deferred.reject(error)
          })
        }
        return deferred.promise
      },
      getDigitalCodeBySecret: function (secret) {
        return new TOTP().getOTP(secret)
      },

      // allAuthData = {
      //    'binduser@test.com':{
      //         {'Coremail' : {secret:'xxxx',xx:'xx'}, owner: 'loginuser@test.com' 'deviceInfo':{}},
      //    }
      //    'binduser':{
      //         {'Coremail' : {secret:'xxxx',xx:'xx'}, owner: 'loginuser@test.com' 'deviceInfo':{},$email:'binduser@test.com'},
      //    }
      // }
      /**
       *  保存绑定账号信息
       * currentUser 当前登录的账号
       * bindUser  需要绑定验证的账号
       * */
      saveAuthData: function (userAuthData) {
        const self = this
        let emailObj, bindEmailName
        const deferred = $q.defer()
        const bindUser = Object.keys(userAuthData)[0]
        userAuthData = userAuthData[bindUser]

        if ($utils.$email.test(bindUser)) {
          // 这里保存两份数据，防止用户在高级登录时未输入邮箱后缀，无法获取信息
          emailObj = $utils.$email.parse(bindUser)
          bindEmailName = emailObj.name
        }

        self.addBindAccounts(bindUser)

        // 这里需要保存所有绑定的信息不需要filterUser
        self.getAllAuthData().then(function (allAuthData) {
          allAuthData[bindUser] = userAuthData
          if (bindEmailName) {
            allAuthData[bindEmailName] = userAuthData || {}
            allAuthData[bindEmailName]['$email'] = bindUser // $email代表对应的email地址
          }
          console.log('saveAllAuthData: ' + JSON.stringify(allAuthData))
        }, function (error) {
          console.log(error)
          const allAuthData = {}
          allAuthData[bindUser] = userAuthData
          if (bindEmailName) {
            allAuthData[bindEmailName] = userAuthData
            allAuthData[bindEmailName]['$email'] = bindUser // $email代表对应的email地址
          }
        })

        return deferred.promise
      },
      // 验证储存的信息的有效性
      validateAuthInfo: function (funQuerySecondAuth) { // 有这里不应该引入service的所以需以参数的形式带过来
        const self = this
        const deferred = $q.defer()
        if (funQuerySecondAuth) {
          self.funQuerySecondAuth = funQuerySecondAuth
        }
        self.getBindAccounts().then(function (bindAccounts) {
          console.log('bindAccounts is =========== ' + JSON.stringify(bindAccounts))
          if (bindAccounts && bindAccounts.length == 0) {
            deferred.resolve([])
          } else {
            _funAllThen(bindAccounts).then(function (emails) {
              console.log('allThen:' + JSON.stringify(emails))
              angular.forEach(emails, function (email, index) {
                if (!email) {
                  emails.splice(index, 1)
                }
              })
              deferred.resolve(emails)
            }, function (error) {
              deferred.reject(error)
            })
          }
        }, function (error) {
          console.log(JSON.stringify(error))
          deferred.resolve('')
        })

        function _funAllThen(bindAccounts) {
          const result = []
          angular.forEach(bindAccounts, function (account) {
            console.log(account + 'is validating')
            if ($utils.$email.test(account)) {
              result.push(self.validateSingleAccount(account).then(function (data) {
                return data
              }))
            }
          })
          return $q.all(result) // 只要一个返回reject，$q.all就会返回reject
        }

        return deferred.promise
      },
      // 验证某个用户的信息
      validateSingleAccount: function (email) {
        const self = this
        const deferred = $q.defer()
        if (self.funQuerySecondAuth) {
          self.funQuerySecondAuth(null, email).then(function (data) {
            const bool = isAuthInfoValid(data, self.allAuthData[email])
            console.log('is info valid : ' + bool)
            if (!bool) { // delete this invalid info form device
              self.removeAuthInfo(email)
              deferred.resolve('')
            } else {
              deferred.resolve(email)
            }
          }, function (error) {
            deferred.reject(error)
            console.log('validateError: ' + JSON.stringify(error))
          })
        } else {
          deferred.reject('')
        }

        return deferred.promise
      },
      // 删除某个验证信息
      removeAuthInfo: function (email) {
        const self = this

        if (self.bindAccounts) {
          angular.forEach(self.bindAccounts, function (emailItem, index) {
            if (email == emailItem) {
              self.bindAccounts.splice(index, 1)
            }
          })
        }

        self.getAllAuthData().then(function (allAuthData) {
          delete self.allAuthData[email]
          if ($utils.$email.test(email)) {
            // 由于保存了两份数据，所以这里还是删除未带邮箱后缀对应的数据
            const emailName = $utils.$email.parse(email) ? $utils.$email.parse(email)['name'] : ''
            const userNameData = (self.allAuthData && emailName) ? self.allAuthData[emailName] : {}
            if (userNameData && userNameData['$email'] == email) {
              delete self.allAuthData[emailName]
            }
          }
          console.log('all :' + JSON.stringify(allAuthData))
        })
      },
      getSecret: function (authData) {
        return getSecret(authData)
      }
    }

    function getSecret(authData) {
      const cmAuthData = authData ? authData['Coremail'] : {}
      return cmAuthData ? cmAuthData['secret'] : ''
    }

    // 服务器返回secret的前五位的值bindKey作为比较的对象, 注意调用querySecondAuth接口不可带issuer字段;
    function isAuthInfoValid(serverInfo, localData) {
      if (serverInfo['var']) {
        const authType = serverInfo['var'].type || ''
        console.log(localData)
        const localSecretPre = getSecret(localData) ? getSecret(localData).slice(0, 5) : ''
        const serverSecretPre = serverInfo['var'].bindKey || ''
        console.log('localSecret_pre is :' + localSecretPre + '; serverSecret_pre is ' + serverSecretPre)
        return !!((authType.toLowerCase() == 'otp' && serverSecretPre == localSecretPre))
      }
      return false
    }

    // http://blog.tinisles.com/2011/10/google-authenticator-one-time-password-algorithm-in-javascript/
    const TOTP = function () {
      function dec2hex(s) {
        return (s < 15.5 ? '0' : '') + Math.round(s).toString(16)
      }

      function hex2dec(s) {
        return parseInt(s, 16)
      }

      function base32toHex(b32) {
        let bits = ''
        let hex = ''
        const b32Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'
        for (let i = 0; i < b32.length; i++) {
          const val = b32Chars.indexOf(b32.charAt(i).toUpperCase())
          bits += leftpad(val.toString(2), 5, '0')
        }

        for (let j = 0; j + 4 <= bits.length; j += 4) {
          const chunk = bits.substr(j, 4)
          hex = hex + parseInt(chunk, 2).toString(16)
        }
        return hex
      }

      function leftpad(str, len, pad) {
        if (len + 1 >= str.length) {
          str = Array(len + 1 - str.length).join(pad) + str
        }
        return str
      }

      this.getOTP = function (secret) {
        let otp
        const key = base32toHex(secret)
        let shaObj = new jsSHA('SHA-1', 'HEX') //eslint-disable-line
        const epoch = Math.round(new Date().getTime() / 1000.0)
        const time = leftpad(dec2hex(Math.floor(epoch / 30)), 16, '0')

        shaObj.setHMACKey(key, 'HEX')
        shaObj.update(time)
        const hmac = shaObj.getHMAC('HEX')
        const offset = hex2dec(hmac.substring(hmac.length - 1))
        otp = (hex2dec(hmac.substr(offset * 2, 8)) & hex2dec('7fffffff')) + ''
        otp = (otp).substr(otp.length - 6, 6)
        return otp
      }
    }

    const authenticatorMap = {}
    return {
      newAuthenticator: function (options) {
        return authenticatorMap[options.CUID] || (authenticatorMap[options.CUID] = new Authenticator(options))
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/infrastructure/authenticator.js